// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuLinks_link__3CeFm","linkContainer":"MenuLinks_linkContainer__3Gqnn"};